import { IconContainer } from '../../Buttons/IconContainer';
import { UnderlinedButton } from '../../Buttons/UnderlinedButton';
import styles from './UploadButtonWrapper.module.css';
import FileIcon from '../../../public/images/icons/file.svg';
import FilesIcon from '../../../public/images/icons/files.svg';
import { ReactNode, useCallback, useContext, useRef } from 'react';
import { CreateContext } from '../../../contexts/CreateContext';
import { AuthContext } from '../../../contexts/AuthContext';
import { login } from '../../../util/account';
import { useRouter } from 'next/router';

export interface UploadButtonWrapperProps {
    label: string;
    description: ReactNode | string;
    icon: any;
    button: string;
    inputProps: Object;
}
export const UploadButtonWrapper = ({ label, description, icon, button, inputProps }: UploadButtonWrapperProps) => {
    const { uploadManager, step, setStep } = useContext(CreateContext);
    const { isLoggedIn } = useContext(AuthContext);
    const ref = useRef<any>();
    const router = useRouter();

    const onButtonClick = useCallback((evt: any) => {
        ref.current.click();
    }, []);

    const onInputClick = useCallback((event: any) => {
        event.target.value = null;
    }, []);

    const onInputChange = (evt: any) => {
        if (!isLoggedIn) {
            login(router, "/create");
            return;
        }
        for (const file of evt.target.files) {
            uploadManager.addFile(file);
        }

        const uploads = uploadManager.getUploads().length;

        if (step === "choose") {
            if (uploads === 1) {
                setStep("info");
            }
            else if (uploads > 1) {
                setStep("gallery");
            }
        }
    };

    return (
        <div onClick={onButtonClick} className={styles.upload_button_wrapper}>
            <div className={styles.upload_button_caption}>
                <IconContainer icon={icon} label={label} responsiveText={false} />
                <p className="text-sm font-thin text-center">{description}</p>

            </div>

            <div className={styles.upload_button}>
                <UnderlinedButton underlineType='primary'>{button}</UnderlinedButton>
            </div>
            <input ref={ref} className="hidden m-0" type="file" {...inputProps} onClick={onInputClick}
             onChange={onInputChange}></input>
        </div>
    )
}